import { TEXT_COLOURS, BRANDED_COLOURS, GRADIENTS, SPIKES_COLOURS } from '@constants';

export const FORM_FIELD = {
  SLIDES: {
    name: 'slides',
    label: 'Current articles',
    rules: [{ len: 6 }],
  },
  TITLE: {
    name: 'title',
    label: 'Module title:',
    placeholder: 'Enter a title for the grid',
    rules: [{ required: true, message: 'Title is required' }],
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [...BRANDED_COLOURS, ...SPIKES_COLOURS, GRADIENTS['gradient-1'].key],
    rules: [{ required: true }],
  },
  TEXT_COLOR: {
    name: 'textColour',
    label: 'Text colour:',
    colors: [...TEXT_COLOURS],
    rules: [{ required: true }],
  },
  ARTICLE: {
    name: 'article',
    rules: [{ required: true, message: 'Article is required' }],
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.SLIDES.name]: [],
  [FORM_FIELD.TITLE.name]: '',
  [FORM_FIELD.BACKGROUND_COLOR.name]: FORM_FIELD.BACKGROUND_COLOR.colors[0],
  [FORM_FIELD.TEXT_COLOR.name]: FORM_FIELD.TEXT_COLOR.colors[0],
};

export const TYPE = {
  BY_TITLE: {
    value: 'title',
    label: 'Choose an article by title',
  },
  BY_TAG: {
    value: 'tag',
    label: 'Choose an article by related tag',
  },
};

export const TYPES = Object.values(TYPE);
